import {eventHelper} from "../../helpers/EventHelper";
import {translator} from "../../services/TranslatorService";

export class EventInteractPlanView {
	constructor() {
		this.$placeToSvg = null;
	}

	getMobilePlacesInfo() {
		return `<div class="interact-plan-info__item interact-plan-info__item_work">
					<div class="interact-plan-info__color"></div>
					<div class="interact-plan-info__text">${translator.t("main", "your seats")}</div>
				</div>
				<div class="interact-plan-info__item interact-plan-info__item_disabled">
					<div class="interact-plan-info__color"></div>
					<div class="interact-plan-info__text">${translator.t("main", "unavailable")}</div>
				</div>`;
	}

	getMobileStadiumPlacesInfo() {
		return `<div class="interact-plan-info__item interact-plan-info__item_sector interact-plan-info__item_disabled">
					<div class="interact-plan-info__color"></div>
					<div class="interact-plan-info__text">${translator.t("main", "unavailable")}</div>
				</div>
				<div class="interact-plan-info__item interact-plan-info__item_sector">
					<button type="button" class="interact-plan-info__reset reset-btn js-prices-reset" style="display: none;">
	          <svg class="icon icon_close">
	              <use xlink:href="#close"></use>
	          </svg>
	          <span class="interact-plan-info__text">${translator.t("main", "Reset")}</span>
          </button>
				</div>`;
	}

	/**
	 * Применяет фильтрацию к секторам по ценовым зонам (легендам цен)
	 * Если у g тегов нет атрибута price то проставляет их
	 */
	renderSvgSectorsByPrices(priceLegends = []) {
		/* Если цена не выбрана то показываем все активные сектора */
		if (!priceLegends.length > 0) return $("g").removeClass("inactive");

		let sectors = $("g[price]");
		const checkedPrices = priceLegends.map(pL => pL.price);
		if (!sectors.length > 0) sectors = eventHelper.setPriceAttributeToSectors();

		/* проходим по каждому сектору и фильтруем по цене */
		$.each(sectors, (i, sector) => {
			const price = $(sector).attr("price");

			if (!price) return false;
			let hasPrice = false;
			$(sector).addClass("inactive");

			/* Преобразуем в массив цены если в атрибуте они указаны как: "3,2,4" и фильтруем по этим ценам */
			$.each(price.split(","), (i, price) => {
				if (checkedPrices.includes(Number(price))) {
					hasPrice = true;
					return false;
				}
			});

			if (hasPrice) $(sector).removeClass("inactive");
		});
	}

	renderSvgSectorsByZones(priceLegends = []) {
		/* Если легенда не выбрана то показываем все активные сектора */
		if (!priceLegends.length > 0) return $("g").removeClass("inactive");

		const checkedZones = priceLegends.map(pL => pL.zoneId);

		$.each($("g[data-zone-id]"), (i, sector) => {
			const zoneIds = $(sector).attr("data-zone-id");

			if (!zoneIds) return false;

			/* Преобразуем в массив зоны если в атрибуте они указаны как: "3,2,4" и фильтруем по этим зонам */
			$.each(zoneIds.split(","), (i, zoneId) => {
				if (checkedZones.includes(Number(zoneId))) {
					$(sector).removeClass("inactive");
				} else {
					$(sector).addClass("inactive");
				}
			});
		});
	}

	setPlaceToSvg($placeToSvg = null) {
		this.$placeToSvg = $placeToSvg || $("#js-change-svg");
	}

	renderSvgPlan(svg) {
		if (!svg) return this.$placeToSvg.html("");
		this.$placeToSvg.html(svg);
	}

	getLinkToSvg() {
		return $(this.$placeToSvg.find("svg")[0]);
	}

	renderSvgPlacesByPrices(priceLegends = []) {
		/* Если цена не выбрана то показываем все активные места */
		if (!priceLegends.length > 0) return $("g").removeClass("inactive");

		const checkedPrices = priceLegends.map(pL => pL.price);

		/* проходим по каждому месту и фильтруем по цене */
		$.each($("g.active"), (i, place) => {
			const price = $(place).attr("data-price");

			if (!price) return false;

			if (checkedPrices.includes(Number(price))) {
				$(place).removeClass("inactive");
			} else {
				$(place).addClass("inactive");
			}
		});
	}

	renderSvgPlacesByZones(priceLegends = []) {
		/* Если цена не выбрана то показываем все активные места */
		if (!priceLegends.length > 0) return $("g").removeClass("inactive");

		const checkedZones = priceLegends.map(pL => pL.zoneId);

		/* проходим по каждому месту и фильтруем по зоне */
		$.each($("g.active"), (i, place) => {
			const zoneId = $(place).attr("zone");

			if (!zoneId) return false;

			if (checkedZones.includes(Number(zoneId))) {
				$(place).removeClass("inactive");
			} else {
				$(place).addClass("inactive");
			}
		});
	}
}
